export const locale = {
  lang: 'en',
  data: {
    DASHBOARD: {
      LOADING: {
        TITLE: 'Loading Dashboard',
        SUBTITLE: 'Please wait while we fetch your data...'
      },
      WELCOME: 'Welcome',
      ADMINISTRATOR: 'Administrator',
      ACADEMIC_YEAR: 'Academic Year',
      SEMESTER: 'Semester',
      SEQUENCE: 'Sequence',
      SYSTEM_STATUS: 'System Status',
      OPERATIONAL: 'Operational',
      ORGANIZATION_OVERVIEW: {
        TITLE: 'Organization Overview'
      },
      STATS: {
        TOTAL_LEARNERS: 'Total Learners',
        TOTAL_STAFF: 'Total Staff',
        RESOURCES: 'Resources',
        TOTAL_COURSES: 'Total Courses',
        ACTIVE: 'Active',
        INACTIVE: 'Inactive',
        ON_LEAVE: 'On Leave',
        NEW_HIRES: 'New Hires',
        CLASSROOMS: 'Classrooms',
        DEPARTMENTS: 'Departments',
        ACTIVE_ENROLLMENT: 'Active Enrollment',
        GROWTH: 'Growth',
        ENROLLED_LEARNERS: 'Enrolled Learners',
        ACTIVE_CLASSROOMS: 'Active Classrooms',
        FACULTY_MEMBERS: 'Faculty Members',
        TOTAL_FEES_COLLECTED: 'Total Fees Collected',
        GROWTH_THIS_MONTH: 'Growth this month',
        GROWTH_THIS_TERM: 'Growth this term'
      },
      FINANCIAL_OVERVIEW: {
        TITLE: 'Financial Overview',
        VIEW_DETAILS: 'View Details',
        TOTAL_EXPECTED: 'Total Expected',
        COLLECTED: 'Collected',
        OUTSTANDING: 'Outstanding',
        DUE: 'Due',
        REMAINING: 'Remaining',
        MONTHLY_REVENUE_TREND: 'Monthly Revenue Trend',
        COLLECTION_RATE: 'Collection Rate',
        FEE_DISTRIBUTION: 'Fee Distribution',
        MONTHLY_COLLECTION_TREND: 'Monthly Collection Trend',
        TOTAL_FEE_AMOUNT: 'Total Fee Amount',
        OUTSTANDING_AMOUNT: 'Outstanding Amount'
      },
      RECENT_TRANSACTIONS: {
        TITLE: 'Recent Transactions',
        VIEW_ALL: 'View All',
        STUDENT: 'Student',
        ID: 'ID',
        METHOD: 'Method',
        STATUS: 'Status',
        AMOUNT: 'Amount',
        RECEIPT_NUMBER: 'Receipt Number',
        LEARNER: 'Learner',
        DATE: 'Date'
      },
      ACADEMICS: {
        TITLE: 'Academics',
        FULL_REPORT: 'Full Report',
        AVG_CLASS_SCORE: 'Avg Class Score',
        RESULTS_PUBLISHED: 'Results Published',
        TOP_PERFORMING_CLASSES: 'Top Performing Classes'
      },
      ASSIGNMENTS: {
        TITLE: 'Assignment Stats',
        TOTAL: 'Total',
        ACTIVE: 'Active',
        PENDING: 'Pending',
        OVERDUE: 'Overdue',
        AVG_COMPLETION_RATE: 'Avg. Completion Rate'
      },
      ACTIVITY: {
        TITLE: 'Recent System Activity',
        NEW_LEARNER_ENROLLMENT: 'New Learner Enrollment',
        RESULTS_PUBLISHED: 'Results Published',
        SYSTEM_ALERT: 'System Alert'
      },
      SYSTEM_HEALTH: {
        TITLE: 'System Health',
        DATA_COMPLETENESS: 'Data Completeness',
        SERVER_UPTIME: 'Server Uptime'
      },
      CALENDAR: {
        TITLE: 'Calendar',
        UPCOMING_EVENTS: 'Upcoming Events',
        VIEW_FULL_CALENDAR: 'View Full Calendar',
        WEEKDAYS: {
          SUN: 'Su',
          MON: 'Mo',
          TUE: 'Tu',
          WED: 'We',
          THU: 'Th',
          FRI: 'Fr',
          SAT: 'Sa'
        },
        EVENTS: {
          FACULTY_MEETING: 'Faculty Meeting',
          PARENT_TEACHER_CONFERENCE: 'Parent-Teacher Conference',
          END_OF_TERM_EXAMS: 'End of Term Exams',
          CONFERENCE_ROOM: 'Conference Room',
          MAIN_HALL: 'Main Hall',
          ALL_CLASSROOMS: 'All Classrooms'
        }
      },
      PENDING_APPROVALS: {
        TITLE: 'Pending Approvals',
        LEAVE_REQUEST: 'Leave Request',
        COURSE_SYLLABUS: 'Course Syllabus',
        REVIEW_DOCUMENT: 'Review Document'
      },
      ALERTS: {
        TITLE: 'System Alerts'
      },
      QUICK_ACTIONS: {
        TITLE: 'Quick Actions',
        COURSES: 'Courses',
        LEARNERS: 'Learners',
        EVALUATIONS: 'Evaluations',
        FEES: 'Fees',
        REPORTS: 'Reports',
        REFRESH: 'Refresh',
        NEW_STUDENT: 'New Student',
        NEW_STAFF: 'New Staff',
        RECORD_PAYMENT: 'Record Payment',
        TAKE_ATTENDANCE: 'Take Attendance',
        ADD_GRADES: 'Add Grades',
        GENERATE_REPORT: 'Generate Report'
      },
      CLASSROOM_DISTRIBUTION: {
        TITLE: 'Classroom Distribution',
        VIEW_ALL_CLASSES: 'View All Classes',
        STUDENTS_PER_CLASSROOM: 'Students per Classroom',
        AVERAGE_CLASS_SIZE: 'Average Class Size',
        TOTAL_CLASSES: 'Total Classes',
        LARGEST_CLASS: 'Largest Class'
      }
    },
    COMMON: {
      APPROVE: 'Approve',
      DENY: 'Deny',
      LOADING: 'Loading...',
      NOT_AVAILABLE: 'N/A'
    }
  }
};
